<template>
  <div class="milestones_lane color-1" :style="justify_content ? `justify-content: ${justify_content};` : 'justify-content: flex-start;'">
    <div v-if="!path" class="milestones_lane_name font-weight-light">{{name}}</div>
    <ButtonOutlined
          v-else
          class="milestones_lane_route_button"
          height="32"
          :text="name"
          color="primary"
          @buttonClicked="routeTo(path)"
        />
    <div 
    :style="
    `background-color: ${lane_color ? lane_color : 'var(--v-primary-base)'}; 
      ${hasLine ? lane_height ? `height: ${lane_height}` : 'height: 1px' : ''};`" 
      :class="hasLine ? 'milestones_lane_line' : ''">
      <slot/>
    </div>
  </div>
</template>
<script>
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue'
  export default {
    components: {
      ButtonOutlined,
    },
    props: ['name', 'justify_content', 'hasLine', 'lane_color', 'lane_height', 'path'],
    methods: {
      routeTo(path) {
        this.$router.push(path)
      },
    }
  }
</script>
<style>
  .milestones_lane {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 50px;
    width: 100%;
  }
  .milestones_lane_name {
    user-select: none;
    line-height: 16px;
    font-size: 16px;
  }
  .milestones_lane_line {
    width: 100%;
    cursor: pointer;
  }
  .milestones_lane_route_button {
    width: 256px;
    position: sticky;
    left: 0px;
  }
</style>
